var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: _vm.containerClass }, [
    _c("div", { staticClass: "invoice-currency-type" }, [_vm._v(" CAD ")]),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.innerValue,
          expression: "innerValue",
        },
      ],
      class: _vm.inputClass,
      attrs: { type: "text", min: "0" },
      domProps: { value: _vm.innerValue },
      on: {
        input: [
          function ($event) {
            if ($event.target.composing) return
            _vm.innerValue = $event.target.value
          },
          _vm.onInput,
        ],
        blur: _vm.emitBlur,
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }